import CheckImagePreviewModal from "components/custom-ui/FullPageModal/components/CheckImagePreviewModal";
import MobileNavView from "components/shared/views/MobileNavView";
import MenuModal from "../../../MenuModal/MenuModal";
import AccountDetailsModal from "./AccountDetailsModal";
import ACHParticipantsModal from "./ACHParticipantsModal";
import AddContactMethodModal from "./AddContactMethodModal";
import AddUnlinkedTransferAccountModal from "./AddUnlinkedTransferAccountModal";
import ChatEndSessionModal from "./ChatEndSessionModal";
import DeleteEmailModal from "./DeleteEmailModal";
import DeletePhoneModal from "./DeletePhoneModal";
import EDEAssociateNoticesModal from "./EDEAssociateNoticesModal";
import EDEHistoryModal from "./EDEHistoryModal";
import EDEStatementModal from "./EDEStatementModal";
import EntryDetailsModal from "./EntryDetailsModal";
import FirstTimeLoginModal from "./FirstTimeLoginModal";
import MakeAPaymentModal from "./MakeAPaymentModal";
import MobileAccountDetailsModal from "./MobileAccountDetailsModal";
import OneTimeACHModal from "./OneTimeACHModal";
import PassThruACHDetailsModal from "./PassThruACHDetailsModal";
import ReviewTransferModal from "./ReviewTransferModal";
import TASPositivePayCancelAddCheckModal from "./TASPositivePayCancelAddCheckModal";
import TASPositivePayCancelEditChangeModal from "./TASPositivePayCancelEditChangeModal";
import TestModal from "./TestModal";
import TransactionInquiryModal from "./TransactionInquiryModal";

export default {
    "TestModal" : TestModal,
    "MakeAPaymentModal" : MakeAPaymentModal,
    "AccountDetailsModal" : AccountDetailsModal, 
    "AddUnlinkedTransferAccountModal" : AddUnlinkedTransferAccountModal,
    "ChatEndSessionModal" : ChatEndSessionModal, 
    "MobileNavView" : MobileNavView,
    "ReviewTransferModal" : ReviewTransferModal,
    "EDEAssociateNoticesModal" : EDEAssociateNoticesModal,
    "EDEHistoryModal" : EDEHistoryModal,
    "EDEStatementModal" : EDEStatementModal,
    "FirstTimeLoginModal" : FirstTimeLoginModal,
    "DeletePhoneModal" : DeletePhoneModal,
    "DeleteEmailModal" : DeleteEmailModal,
    "AddContactMethodModal" : AddContactMethodModal,
    "CheckImagePreviewModal" : CheckImagePreviewModal,
    "MobileAccountDetailsModal" : MobileAccountDetailsModal,
    "OneTimeACHModal": OneTimeACHModal,
    "ACHParticipantsModal": ACHParticipantsModal,
    "PassThruACHDetailsModal": PassThruACHDetailsModal,
    "TransactionInquiryModal": TransactionInquiryModal,
    "TASPositivePayCancelAddCheckModal": TASPositivePayCancelAddCheckModal,
    "TASPositivePayCancelEditChangeModal": TASPositivePayCancelEditChangeModal,
    "MenuModal":MenuModal,
    "EntryDetailsModal": EntryDetailsModal
};